import React from "react";
import { LiveDashboard } from "../components/sections/LiveDashboard";
import { Seo } from "../components/Seo";
import { useI18n } from "../i18n/I18nContext";

export default function DashboardPage() {
  const { t } = useI18n();
  return (
    <main className="pt-40 lg:pt-36 pb-8" data-testid="dashboard-page">
      <Seo k="dashboard" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-6 pb-4">
        <div className="eyebrow mb-3">{t.dash.eyebrow}</div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter max-w-3xl">{t.dash.title}</h1>
        <p className="text-slate-400 mt-4 text-lg max-w-2xl">{t.dash.sub}</p>
      </div>
      <LiveDashboard />
    </main>
  );
}
